import bridge from '@vkontakte/vk-bridge'
import {
    getInVk,
    getIsVkAppAdmin,
    setCheckWorkabilityFn,
    setResolved,
    setStoreUrl,
    setMessagesDisabled,
    setMessagesRejected,
    setTokenRejected
} from '@/composables/context'
import {API, client} from '@/services/http'
import {toBuyoutItemState} from '@/services/routing'

const groupManageSettings = 262144
const groupMessageSettings = 4096
const groupWidgetSettings = 64
const groupAllSettings = groupManageSettings + groupMessageSettings + groupWidgetSettings
const tokenTypes = {
    EMPTY: 'empty',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected'
}
const messageTypes = {
    DISABLED: 'disabled',
    EMPTY: 'empty',
    REJECTED: 'rejected',
    ACCEPTED: 'accepted'
}

let _appId = null
let _currentSourceId
let _refreshEnabled = true

function groupId () {
    return _currentSourceId * -1
}
function hasSourceContext () {
    return !!_currentSourceId
}
function _makeStoreUrl (sourceId, storeId) {
    return storeId ? `https://vk.com/app${storeId}_${sourceId}` : null
}
function messGet(){
    bridge.send('VKWebAppAllowMessagesFromGroup', {
        'group_id': groupId(),
        'key': `${new Date().getTime()}`
    })
        .then(() => _messAccept())
        .catch(() => _messReject())
        .finally(() => setResolved(true))
}
function _messGetFromBE () {
    setResolved(false)
    client.get(API.ACCESS.MESSAGES.GET, {params: {sourceId: _currentSourceId}}).then(rs => {
        _processMessagesRs(rs.type, true)
        setResolved(true)
    })
}
function _processMessagesRs (type, get) {
    switch (type){
        case messageTypes.DISABLED:
            if (getIsVkAppAdmin()) {
                setMessagesDisabled(true)
            }
            break
        case messageTypes.ACCEPTED:
            setMessagesRejected(false)
            break
        case messageTypes.EMPTY:
        case messageTypes.REJECTED:
            if (get){
                messGet()
            }
            setMessagesRejected(true)
            break
    }
}
function _messAccept () {
    client.post(API.ACCESS.MESSAGES.ACCEPT, {sourceId: _currentSourceId}).then(
        () => _processMessagesRs(messageTypes.ACCEPTED)
    )
    setMessagesRejected(false)
}
function _messReject () {
    client.post(API.ACCESS.MESSAGES.REJECT, {sourceId: _currentSourceId}).then(
        () => _processMessagesRs(messageTypes.REJECTED)
    )
    setMessagesRejected(true)
}
function tokenGet () {
    bridge.send('VKWebAppGetCommunityToken', {
        'app_id': _appId,
        'group_id': groupId(),
        'scope': 'messages,app_widget,manage'
    })
        .then(rs => {
        const token = rs.access_token
        _checkToken(token).then(rs => {
            if (rs.response.mask === groupAllSettings) {
                _tokenAccept(token)
            } else {
                _tokenReject()
            }
        })
            .catch(() => _tokenReject())
            .finally(() => setResolved(true))
    })
        .catch(() => _tokenReject())
}
function _tokenGetFromBE () {
    setResolved(false)
    client.get(API.ACCESS.TOKEN.GET, {params: {sourceId: _currentSourceId}}).then(rs => {
        _processTokenRs(rs.type)
        setResolved(true)
    })
}
function _processTokenRs (type) {
    switch (type) {
        case tokenTypes.ACCEPTED:
          setTokenRejected(false)
          _messGetFromBE()
          break
        case tokenTypes.EMPTY:
        case tokenTypes.REJECTED:
          tokenGet()
          setTokenRejected(true)
          break
    }
}
function _tokenAccept (token) {
    client.post(API.ACCESS.TOKEN.UPDATE, {sourceId: _currentSourceId, token: token}).then(() => {
        setTokenRejected(false)
        _messGetFromBE()
    })
}
function _tokenReject () {
    client.post(API.ACCESS.TOKEN.REJECT, {sourceId: _currentSourceId}).then(() => setTokenRejected(true))
}
function _storeIdGet (sourceId) {
    client.get(`${API.STORE.INSTALLED}?sourceId=${sourceId}`)
        .then(rs => {
            if (rs.installed) {
                setStoreUrl(_makeStoreUrl(sourceId, rs.appId))
            }
        })
}
function _initVkApp () {
    bridge.send('VKWebAppInit')
        .then((data) => {
            if (data.result) {
                bridge.subscribe(({ detail: { type, data }}) => {
                    if (type === 'VKWebAppChangeFragment' && data.location) {
                        toBuyoutItemState(_currentSourceId, data.location)
                    }
                    if (type === 'VKWebAppViewRestore') {
                        if (_refreshEnabled){
                            checkWorkability(_currentSourceId, true)
                        }
                    }
                })
            } else {
                console.log(data)
            }
        })
        .catch((error) => {
            console.log(error)
        })
}
function check (context) {
    if (context) {
        console.log('Received app context', context)
        _appId = +context.vk_app_id
        _initVkApp()
    } else {
        setResolved(true)
    }
    return context
}
function enableRefresh (enable = true) {
    _refreshEnabled = enable
}
function checkWorkability (sourceId, forse = false) {
    if (_currentSourceId !== sourceId) {
        setStoreUrl(null)
    }
    if (!getInVk() || !sourceId || sourceId > 0 || (!forse && _currentSourceId === sourceId)) {
        return
    }
    _currentSourceId = sourceId
    _storeIdGet(_currentSourceId)
    _clearPermissions()
    if (getIsVkAppAdmin()) {
        _tokenGetFromBE()
    } else {
        _messGetFromBE()
    }
}
function clearSourceData () {
    _clearPermissions()
    _currentSourceId = null
}
function closeApp () {
    return bridge.send('VKWebAppClose', {'status': 'success'})
}
function copyText (text) {
    return bridge.send('VKWebAppCopyText', {text})
}
function resizeWindow (width, height) {
    return bridge.send('VKWebAppResizeWindow', {width, height})
}
function getGroupMessageSettingsUrl () {
    return `https://vk.com/club${groupId()}?act=messages`
}
function getWidgetPreview (type, code) {
    return bridge.send('VKWebAppShowCommunityWidgetPreviewBox', {
        'group_id': groupId(),
        type,
        code
    })
}
function windowOpen (url) {
    const link = window.document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
    link.href = url
    link.target = '_blank'

    const event = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
    })
    link.dispatchEvent(event)
}
function _checkToken (token) {
    return bridge.send('VKWebAppCallAPIMethod', {
        'method': 'groups.getTokenPermissions',
        'request_id': new Date().getTime(),
        'params': {
            'v': '5.103',
            'access_token': token
        }
    })
}
function _clearPermissions () {
    setTokenRejected(false)
    setMessagesDisabled(false)
    setMessagesRejected(false)
}

function getVKClientVersion() {
    return bridge.send("VKWebAppGetClientVersion")
}

setCheckWorkabilityFn(checkWorkability)

export {
  check,
  clearSourceData,
  closeApp,
  copyText,
  enableRefresh,
  getGroupMessageSettingsUrl,
  getWidgetPreview,
  hasSourceContext,
  messGet,
  resizeWindow,
  tokenGet,
  windowOpen,
  getVKClientVersion
}
